import {visit} from 'unist-util-visit'

import {agentMentionPattern} from '../agents-helpers'
import type {UserMessageTree} from './user-message-tree'

/**
 * splits text into alternating prose / code-fence segments, handling
 * fences of any length (3+) by matching opening and closing runs of equal length
 * via a backreference.
 */
export function splitCodeFences(text: string): string[] {
  const result: string[] = []
  const fenceRe = /(^|\n)(`{3,})[^\n]*\n[\s\S]*?(?:\n\2\s*(?=\n|$)|$)/g
  let lastIndex = 0

  for (const match of text.matchAll(fenceRe)) {
    const fenceStart = match.index + match[1]!.length // skip the leading \n captured in group 1
    if (fenceStart > lastIndex) result.push(text.slice(lastIndex, fenceStart))
    result.push(text.slice(fenceStart, match.index + match[0].length))
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) result.push(text.slice(lastIndex))
  return result.filter(s => s !== '')
}

export function getAllMentionedReferenceIds(tree: UserMessageTree) {
  const result = new Set<string>()
  visit(tree, node => {
    if (node.type === 'reference-mention' && node.data.mentionedReferenceId !== undefined)
      result.add(node.data.mentionedReferenceId)
  })
  return result
}

export function isCodeFenceSegment(segment: string): boolean {
  return /^`{3,}[^\n]*\n/.test(segment)
}

export function extractCodeContent(fenceSegment: string): string {
  const fenceLen = /^(`{3,})/.exec(fenceSegment)![1]!.length
  const firstNewline = fenceSegment.indexOf('\n')
  if (firstNewline === -1) return ''
  return fenceSegment.slice(firstNewline + 1).replace(new RegExp(`\n\`{${fenceLen}}\\s*$`), '')
}

export function hasPotentialAgentMention(messageText: string): boolean {
  const segments = splitCodeFences(messageText)
  return segments.some(segment => agentMentionPattern.test(segment.trimStart().split(/\s/)[0] ?? ''))
}
